import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-page-404',
  imports: [CommonModule],
  templateUrl: './page-404.html',
  styleUrl: './page-404.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Page404 {
  private router = inject(Router);

  goBack() {
    this.router.navigate(['/']);
  }
}
